APP.Layout = (/** @lends APP.Layout */function () {
	'use strict';

	var exports = {},
		installmentAvailable = 'check',
		$body;


	function init() {
		$body = APP.Performance.getCachedDOM().$body;

		setTimeout(checkLayoutOverlayCalls, 10);
		initBindings();
		checkVideoBlockVisibility();

		$body.find('[data-send-track]').each(function () {
			APP.Analytics.sendStickyTrack($(this).attr('data-send-track'));
		});

		$body.on({
			click: function (e) {
				var href = $(this).attr('href');

				if (href && href.match(/:\/\//g) && !href.match(/yettel.hu/g)) {
					e.preventDefault();
					APP.Analytics.trackEventOnLink(href, 'External', 'Click', href);
				}
			}
		}, 'a:not([data-ga])');

		$body.find('[data-selectric]').selectric({
			arrowButtonMarkup: '<div class="selectric-button"><i class="icon-wrapper"><svg viewBox="0 0 256 256"><use xlink:href="#icon-chevron-down"></use></svg></i></div>',
			preventWindowScroll: true,
			responsive: true
		});

		/*
			Example:
			<link data-set-track="Registration" data-action="Action" data-label="Label" data-value="Value" />
		 */
		$body.find('[data-set-track]').each(function () {
			APP.Analytics.setStickyTrack(
				$(this).attr('data-set-track'),
				$(this).attr('data-action'),
				$(this).attr('data-label'),
				$(this).attr('data-value')
			);
		});

		initStateGroup();
	}

	function checkLayoutOverlayCalls() {
		var $errorDisplay = $body.find('[data-error-display]');

		if ($body.find('[data-open-login-overlay]').length > 0) {
			if (APP.Maintenance.isLoginDisabled() === true) {
				APP.Maintenance.showDisabledLoginLayer();
			} else {
				APP.Login.open({
					loginState: $body.find('[data-open-login-overlay]').attr('data-open-login-overlay') === '1tp' ? '2' : '1'
				});
				APP.Analytics.setStickyTrack('Registration', 'Direct', null, null);
			}
		} else if ($errorDisplay.length > 0) {
			APP.Layout.alert($errorDisplay.attr('data-error-display'), $errorDisplay.attr('data-error-title'));
		}
	}

	function checkInstallments(result) {
		if (result && result.data && result.data.installments) {
			$body.find('[data-menu-device-installment]').each(function () {
				installmentAvailable = true;
				$(this).addClass('active');
			});
		} else if (installmentAvailable === true) {
			$body.find('[data-menu-device-installment]').each(function () {
				$(this).addClass('active');
			});
		}
	}

	function initBindings() {
		APP.Bind.click({
			'change-email': initChangeEmail,
			'close-video-block': initVideoCloser,
			'toggle-subscription-class': initSubscriptionClassToggle,
			'change-tab': changeTab,
			'open-overlay-with-tpl': openOverlayWithTpl,
			'ca-settings': caSettings,
			'ctn-settings': ctnSettings,
			'select-account': selectAccount,
			'show-more': showMore,
			'btn-add-loader': btnAddLoader,
			'sticky-track': stickyTrack,
			'pop-sticky-track': popStickyTrack,
			'block-disabler': blockDisabler,
			'set-auth-access': setAuthAccess,
			'start-video': startVideo,
			'reset-form': resetForm,
			'set-radio-block-state': setRadioBlockState
		});

		APP.Bind.focus({
			'input-edit': inputEditFocus
		});

		APP.Bind.blur({
			'input-edit': inputEditBlur
		});

		APP.Bind.keyup({
			'notification-keyup': notificationKeyup,
			'enable-consent-save-button': setBlockSaveState
		});

		APP.Bind.change({
			'toggle-hide-image': function () {
				$body.find('[data-img-wrap]').toggleClass('block--display-none');
			},
			'ca-accordion': caAccordion,
			'toggle-notification': toggleNotification,
			'change-billing-select': changeBillingSelect,
			'change-profile-type': changeProfileType,
			'advance-select': ctnAdvanceSelect,
			'enable-consent-save-button': setBlockSaveState
		});

		$body.on('focus', '.checkbox--wrapper--disabled > input', function () {
			$(this).blur();
		});

		$body.on('click', '.checkbox--wrapper--disabled', function (e) {
			e.preventDefault();
		});
	}

	function startVideo() {
		var $videoContainer = $body.find('.landing__promo-video');

		if ($videoContainer !== null) {
			$videoContainer.addClass('landing__promo-video--play');
			APP.Youtube.playVideo('indexPlayer');
		}
	}

	function blockDisabler(e, target) {
		if ($body.find('[' + target + ']').attr(target) === 'enabled') {
			$body.find('[' + target + ']').attr(target, 'disabled');
		} else {
			$body.find('[' + target + ']').attr(target, 'enabled');
		}
	}

	function setRadioBlockState(e, data) {
		var dataObj = JSON.parse(data),
			$target = $body.find(dataObj.target),
			setDisabled = dataObj.setDisabled === 'true';

		if ($target.length > 0 && $target.hasClass('radio-wrapper')) {
			if (setDisabled) {
				$target.addClass('radio-wrapper--disabled');
				$target.find('input').attr('disabled', 'disabled');
				$target.find('select').attr('disabled', 'disabled');
			} else {
				$target.removeClass('radio-wrapper--disabled');
				$target.find('input').removeAttr('disabled');
				$target.find('select').removeAttr('disabled');
			}
		}
	}

	function setBlockSaveState(e, data) {
		$(data).removeAttr('disabled');
		$(data).removeClass('button--disabled');
	}

	function notificationKeyup(e, arg) {
		var $form = $(e.currentTarget).parents('form');

		if ($(e.currentTarget).val() === '') {
			$form.find('[data-notification-type=' + arg + ']').prop('checked', false);
		} else {
			$form.find('[data-notification-type=' + arg + ']').prop('checked', true);
		}
	}

	function btnAddLoader(e) {
		$(e.currentTarget).addClass('button--loading');
	}

	function setAuthAccess(e, arg) {
		if ($body.find('[name="NonAuthAccessAllowed"]').length) {
			$body.find('[name="NonAuthAccessAllowed"]').val(arg);
		}
	}

	function stickyTrack(e, arg) {
		var argObj = JSON.parse(arg);

		if (argObj) {
			APP.Analytics.setStickyTrack(argObj.category, argObj.action, argObj.label, argObj.value);
		}

	}

	function resetForm(e) {

		$(e.currentTarget).parents('form').find('input, select').each(function () {
			var $this = $(this);

			if (typeof $this.attr('data-no-reset') !== 'undefined') {
				return;
			}


			if ($this.attr('type') === 'radio' || $this.attr('type') === 'checkbox') {
				if ($this.attr('data-original-state') === 'checked') {
					$this.prop('checked', true);
				} else {
					$this.prop('checked', false);
				}

				if ($this.attr('type') === 'radio') {
					$(e.currentTarget).parents('form').find('[name=' + $this.attr('name') + ']:checked').trigger('change');
				}
			}

			setTimeout(function () {

				$this.val($this.attr('data-original-value'));
				if (typeof $this.attr('data-selectric') !== 'undefined') {
					$this.selectric('refresh');
				}
			}, 10);

		});
	}

	function popStickyTrack(e, arg) {
		APP.Analytics.popStickyTrack(arg);
	}

	function showMore(e, target) {
		$('[' + target + ']').toggleClass('show-more--hidden');
		$(e.currentTarget).toggleClass('opened');

		if ($(e.currentTarget).hasClass('opened')) {
			$(e.currentTarget).text('Elrejt');
		} else {
			$(e.currentTarget).text('Bővebben');
		}

		APP.Tooltip.reposition();
		e.preventDefault();
	}

	function inputEditFocus(event) {
		if (typeof $(event.currentTarget).attr('data-original-value') === 'undefined' ||
			$(event.currentTarget).val() !== $(event.currentTarget).attr('data-original-value')) {
			return;
		}

		$(event.currentTarget).val('');
	}

	function inputEditBlur(event) {
		if (typeof $(event.currentTarget).attr('data-original-value') === 'undefined' || $(event.currentTarget).val() !== '') {
			return;
		}

		$(event.currentTarget).val($(event.currentTarget).attr('data-original-value'));
	}

	function selectAccount(event, ctn) {
		var params = { ctn: ctn };

		$(event.currentTarget).addClass('loading').text('');
		$(event.currentTarget).append(APP.Template.get('loader-anim')());

		if (typeof $(event.currentTarget).attr('data-scroll-to-campaigns') !== 'undefined') {
			params.scrollToCampaigns = true;
		}

		APP.Service.post(params, $body.find('[data-select-account-url]').attr('data-select-account-url'))
			.done(function (response) {
				if (response.redirect) {
					document.location.href = response.redirect;
				} else {
					$(event.currentTarget).removeClass('loading').text('Kiválaszt');
				}
			});

	}

	function initChangeEmail() {
		window.$element('email').removeAttr('readonly').focus().select();
	}

	function initVideoCloser() {
		window.$element('video-box').addClass('block--display-none');
		window.setCookie('hide-welcome-video', 1);
	}

	function initSubscriptionClassToggle(event, argument) {
		window.$element('subscription-wrapper').toggleClass(argument);
	}

	function checkVideoBlockVisibility() {
		if (window.getCookie('hide-welcome-video')) {
			window.$element('video-box').addClass('block--display-none');
		}
	}

	function changeTab(event, args) {
		var prop = window.parseJSON(args);

		console.log('parse 3');

		window.$element(prop.tab).attr('data-tab-active', parseInt(prop.active, 10) + 1);
		window.$element(prop.brother).addClass('button--grey');
		$(event.target).removeClass('button--grey');
	}

	function openOverlayWithTpl(event, argument) {
		var argData,
			overlayTemplate;

		try {
			argData = window.parseJSON(argument);
			overlayTemplate = APP.Template.get(argData.tpl);
			APP.Overlay.setContent(overlayTemplate(argData));
			APP.Overlay.open();
		} catch (error) {
			if (window.console) {
				console.warn(error);
			}
		}

	}

	/**
	 * State group handles different view states in a group
	 * @return {void}
	 */
	function initStateGroup() {
		$body.on('click', '[data-set-state]', function (e) {

			$(this).parents('[data-state-group]').attr('data-state-active', $(this).attr('data-set-state'));

			e.preventDefault();
		});
	}

	function caSettings(event, ca) {
		$(event.currentTarget).addClass('loading').text('');
		$(event.currentTarget).append(APP.Template.get('loader-anim')());
		APP.Service.post({ca: ca}, '/api/v1/account/ca-settings').then(function (result) {
			if (result.success) {
				document.location.href = result.redirect;
			} else if (window.console) {
				$(event.currentTarget).removeClass('loading').text('Beállítások');
				console.error(result.errors);
			}
		});

	}

	function ctnSettings(event, ctn) {
		APP.Service.post({ctn: ctn}, '/api/v1/account/ctn-settings').then(function (result) {
			if (result.success) {
				document.location.href = result.redirect;
			} else if (window.console) {
				console.error(result.errors);
			}
		});

	}

	function reload(trackLogin) {
		if (trackLogin) {
			// track login
			APP.Analytics.setStickyTrack(
				'Belepes',
				null,
				'SMS',
				null
			);
			APP.Analytics.sendStickyTrack('Belepes');
		}
		document.location.reload();
	}

	function alert(message, title) {
		var prefix = '';

		if (title) {
			prefix = '<h1 class="text--size-18 text--color-text-grey block--margin-bottom-half">' +
				title +
				'</h1><div class="hr-gradient hr-gradient--small hr-gradient--grey hr-gradient--no-margin"></div><br>';
		}

		APP.Overlay.setContent(prefix + '<span class="block block--margin-bottom text text--size-18">' + message + '</span><button data-close-overlay class="button block--full-width">Ok</button>', true, false, 'overlay--error');
		APP.Overlay.open();
	}

	/*
	 * This function used for update static texts from input fields
	 */
	function caBillingEditForm(a, $form) {
		var $valueBoxContainer = $form.parents('[data-values-box]');

		if(typeof $form.attr('data-global-value-update') !== 'undefined' && $form.attr('data-global-value-update') === 'true') {
			$valueBoxContainer = $body;
		}

		function getFieldValue(input) {
			var text = '';

			if (typeof input.attr('data-selectric') !== 'undefined') {
				text += input.val() !== '' ? input.find('option[value="' + input.val() + '"]').text() : '';
			} else if (input.attr('type') === 'radio') {
				text += $form.find('[name="' + input.attr('name') + '"]:checked').parents('label').find('[data-label]').html();
			} else {
				text += input.val();
			}

			text = text.trim();
			return text;
		}

		$valueBoxContainer.find('[data-value]').each(function () {

			var fields = $(this).attr('data-value').split(';'),
				input = null,
				text = '',
				i = 0,
				k = 0,
				fieldSeparator = null;

			for (i = 0; i < fields.length; i++) {
				fieldSeparator = fields[i].split('|');

				if (fieldSeparator.length > 1) {
					for (k = 0; k < fieldSeparator.length; k++) {
						input = $form.find('[name="' + fieldSeparator[k] + '"]');

						if (input.length) {
							text += getFieldValue(input);
							if (text === '') {
								break;
							}
						} else {
							text += fieldSeparator[k];
						}
					}
				} else {
					input = $form.find('[name="' + fields[i] + '"]');

					if (input.length) {

						text += getFieldValue(input);

					} else {
						text += fields[i];
					}
				}

			}

			$(this).html(text);

		});

		$form.find('input, select').each(function () {
			var $this = $(this);

			if (typeof $this.attr('data-no-reset') !== 'undefined') {
				return;
			}

			$this.attr('data-original-value', $this.val());

			if ($this.attr('type') === 'radio' || $this.attr('type') === 'checkbox') {
				if ($this.prop('checked')) {
					$this.attr('data-original-state', 'checked');
				} else {
					$this.attr('data-original-state', '');
				}
			}

		});

		$form.parents('[data-state-active]').attr('data-state-active', 1);

	}

	function caAccordion(e) {
		$body.find('[data-accordion-item]').removeClass('accordion-show');
		$body.find('[data-accordion-item="' + $(e.currentTarget).val() + '"]').addClass('accordion-show');
	}

	function toggleNotification(e, arg) {

		$(e.currentTarget).parents('form').find('[data-notification]').each(function () {
			var $this = $(this);

			if ($this.attr('data-notification') === 'text') {
				if (parseInt(arg, 10)) {
					$this.prop('disabled', true);
				} else {
					$this.prop('disabled', false);
				}
			} else if ($this.attr('data-notification') === 'checkbox') {
				if (parseInt(arg, 10)) {
					$this.parents('.checkbox--wrapper').addClass('checkbox--wrapper--disabled');
					$this.prop('disabled', true);
					$this.prop('checked', false);
				} else {
					$this.parents('.checkbox--wrapper').removeClass('checkbox--wrapper--disabled');
					$this.prop('disabled', false);
				}
			}


		});
	}

	function changeBillingSelect(e, isFull) {
		var billingSelect = $('[data-billingpayment-method]'),
			optionsList = [
						{
							value: 'BankTransfer',
							label: 'Banki utalás',
							onFull: true
						},
						{
							value: 'Regular',
							label: 'Postai csekk',
							onFull: false
						}
					],
					option,
					i,
					selectedValue = billingSelect.find('option:selected').attr('value'),
					isSelected = false;

		if (billingSelect.attr('disabled') === undefined) {

			billingSelect.empty();

			for (i = 0; i < optionsList.length; i++) {
				option = optionsList[i];

				if (parseInt(isFull, 10) && !option.onFull) {
					continue;
				}

				isSelected = selectedValue === option.value ? ' selected' : '';

				billingSelect.append('<option' + isSelected + ' value="' + option.value + '">' + option.label + '</option>');
			}
			billingSelect.selectric('init');
		}
	}

	function changeProfileType(e, arg) {
		var $form = $(e.currentTarget).parents('form'),
			$valueBoxContainer = $form.parents('[data-values-box]');

		if(typeof $form.attr('data-global-value-update') !== 'undefined' && $form.attr('data-global-value-update') === 'true') {
			$valueBoxContainer = $body;
		}

		$valueBoxContainer.find('[data-profile-type]').addClass('hidden');
		$valueBoxContainer.find('[data-profile-type]').find('input').prop('disabled', true).attr('data-no-disable', true);
		$valueBoxContainer.find('[data-profile-type=' + arg + ']').removeClass('hidden');
		$valueBoxContainer.find('[data-profile-type=' + arg + ']').find('input').prop('disabled', false).removeAttr('data-no-disable');
	}

	function ctnAdvanceSelect(e) {
		var amountAttr = $(e.currentTarget).find('option[value=' + $(e.currentTarget).val() + ']').attr('data-fix-amount'),
			amountInput = $body.find('[data-advance-input]');


		if(typeof amountAttr !== 'undefined') {
			amountInput.val(amountAttr).attr('readonly', true);
		} else {
			amountInput.val('').attr('readonly', false);
		}
	}

	exports.init = init;
	exports.reload = reload;
	exports.alert = alert;
	exports.blockDisabler = blockDisabler;
	exports.caBillingEditForm = caBillingEditForm;
	exports.caAccordion = caAccordion;
	exports.checkInstallments = checkInstallments;

	return exports;

}());
